import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AdministradorService } from 'src/app/services/administrador.service';

@Component({
  selector: 'app-explotaciones',
  templateUrl: './explotaciones.component.html',
  styleUrls: ['./explotaciones.component.scss']
})
export class ExplotacionesComponent implements OnInit {

  intIdExplotacion:any;
  isSelected=false;

  constructor(private thisDialogRef: MatDialogRef<MatDialog>, @Inject(MAT_DIALOG_DATA) private data: any,
              private miservcio:AdministradorService) { }

  ngOnInit() {
    // console.log(this.data)
  }

  guardar(){
    if(this.intIdExplotacion!=undefined){
      this.isSelected=false;
      this.thisDialogRef.close(this.intIdExplotacion);
    }
    else{
      this.isSelected=true;
    }
  }

  selectExplotacion(){
    // console.log(this.intIdExplotacion)
  }

  cancelar(){
    this.thisDialogRef.close();
  }

}
